module.exports = __webpack_public_path__ + "static/media/cogs.7e5fbf35.svg";